import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getMessageGrowth = ({ churchId, fromDate, toDate, period }) => {
  return axios.get(
    `/churches/${churchId}/dashboard/messages-growth-data?from_date=${fromDate}&to_date=${toDate}&period=${period}`
  );
};

export const useMessageGrowth = ({
  churchId,
  fromDate,
  toDate,
  period,
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: ["message-growth", churchId, fromDate, toDate, period],
    queryFn: () => getMessageGrowth({ churchId, fromDate, toDate, period }),
    select: response => response.result,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
    staleTime: 0,
    cacheTime: 0
  });
};
